import styles from './reason-to-buy.module.scss'

export default function ReasonToBuy() {
  return (
    <section className={styles.reasonToBuy}>
      <h2 className={styles.text}>
        9 เหตุผลทำไมท่านควรซื้อสายนาฬิกาและ
        Accessories กับ Expert Watch
      </h2>
      <div className={styles.reasonList}>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/price.png" />
          <div className={styles.desc}>ราคาจับต้องได้ คุณภาพคุ้มเกินราคา</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/collection.png" />
          <div className={styles.desc}>มีคอลเลกชั่นให้เลือก จากแบรนด์ดังทั่วโลก</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/measure.png" />
          <div className={styles.desc}>บริการวัดขนาด เปลี่ยนสายฟรี</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/truck.png" />
          <div className={styles.desc}>จัดส่งฟรีผ่าน Kerry หรือ EMS</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/lightbulb.png" />
          <div className={styles.desc}>ให้คำปรึกษาโดย ผู้เชี่ยวชาญ</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/watch.png" />
          <div className={styles.desc}>ประกันคุณภาพสาย นาฬิกา 1 ปี</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/point.svg" />
          <div className={styles.desc}>สะสมคะแนน ซื้อมากยิ่งได้มาก</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/watch-strap.png" />
          <div className={styles.desc}>บริการรับสั่งตัดสาย หนังวัวและจระเข้</div>
        </div>
        <div className={styles.reason}>
          <img className={styles.icon} src="/icon/accessories/office.png" />
          <div className={styles.desc}>สะดวกสบายด้วย 9 สาขาใกล้บ้านคุณ</div>
        </div>
      </div>
    </section>
  )
}
